export type CustomerSliderType = {
  customerMessage: string;
  customerName: string;
  customerImage: string;
};

export const customerSlider: CustomerSliderType[] = [
  {
    customerMessage:
      "Felt very confident with Swyft from the start, really helped me understand Solar PV. From the online application to the installation, the whole process was very easy. Solar PV has reduced our electricity bills and improved the BER rating in our house.",
    customerName: "Peter O’Mahony,<br/> LIONS, IRELAND AND MUNSTER RUGBY CAPTAIN",
    customerImage: "images/customers/peter.webp"
  },
  {
    customerMessage:
      "With twelve months complete since the installation the results have exceeded expectations and met my objectives. The return on investment, taking into account the grants and accelerated capital allowances, have made this a very good investment.",
    customerName: "PJ O'HALLORAN",
    customerImage: "images/customers/pj.webp"
  },
  {
    customerMessage:
      "From start to finish it was faultless, the staff in the office were so helpful on the phone and getting an installation date was very quick. The engineer doing the install was so efficient and there was very little to clean up considering what a big job it was. I am so happy we went with Swyft would definitely recommend them.",
    customerName: "CATRIONA CRONIN",
    customerImage: "images/customers/catriona.webp"
  }
];
